import React from "react";
import { Button } from "../../../components/Button";
import exclamation from "../../../assets/images/SVG/credit.svg";


const ModalPago = ({ titulo = "Advertencia", cuerpo, onCancel, onSuccess }) => {
  return (
    <div id="centeredModal" className="modal-wrapper modal-is-open">
      <div className="overlay"></div>
      <div className="modal modal-centered">
        <div className="modal-content rounded-lg bg-white p-10 flex flex-col w-2/3">
          <div className="flex flex-col items-center justify-center">
            <img src={exclamation} alt="Exclamation icon" className="w-1/3 h-24 w-24" />
            <div className="text-primary text-opacity-700 text-4xl text-center mt-5 font-bold leading-none">
              {titulo}
            </div>
          </div>
          <div className="flex flex-col items-center justify-start">
            <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
              {cuerpo.encabezado}
            </p>
            {cuerpo.factura &&<p className="text-primary opacity-75 text-2xl text-center leading-none mt-3">
              Factura: {cuerpo.factura}
            </p>}
            <p className="text-primary opacity-75 text-2xl text-center leading-none">
              Monto: {cuerpo.monto}
            </p>
            <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
              {cuerpo.validacion}
            </p>
          </div>
          <div className="w-2/3 mx-auto mt-5 items-center justify-center">
            <Button
              className="btn btn-outline btn-xs btn-primary w-full"
              onClick={onSuccess}
            >
              <label className="flex flex-col text-center text-xl items-center">
                Aceptar
              </label>
            </Button>
            <Button
              className="btn btn-outline btn-xs btn-danger w-full mt-2"
              onClick={onCancel}
            >
              <label className="flex flex-col text-center text-xl items-center">
                Cancelar
              </label>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPago;
